// src/components/TrainingTourBanner.jsx
import {
  FaGraduationCap,
  FaPenNib,
  FaCameraRetro,
  FaFilm,
  FaVideo,
  FaRobot,
  FaPaintBrush,
  FaBullhorn,
  FaPalette,
  FaMagic,
  FaUsers,
} from "react-icons/fa";
import "../styles/banner.css";

const trainingPrograms = [
  {
    title: "SÁNG TẠO NỘI DUNG & FACEBOOK ADS",
    icon: <FaPenNib className="banner__icon" />,
    items: [
      { text: "Viết Content hấp dẫn", icon: <FaPenNib /> },
      {
        text: "Công thức quảng cáo (AIDA, PAS, Storytelling…)",
        icon: <FaBullhorn />,
      },
      { text: "Thực hành bài viết Facebook", icon: <FaPalette /> },
      { text: "Chạy Ads cơ bản & tối ưu", icon: <FaVideo /> },
    ],
  },
  {
    title: "NHIẾP ẢNH & QUAY PHIM THỰC CHIẾN",
    icon: <FaCameraRetro className="banner__icon" />,
    items: [
      { text: "Làm chủ ISO – Khẩu – Tốc độ", icon: <FaCameraRetro /> },
      { text: "Quay chân dung, sản phẩm, phỏng vấn", icon: <FaFilm /> },
      { text: "Thực hành ngoài trời & studio", icon: <FaVideo /> },
      { text: "Bộ ảnh & video chuyên nghiệp", icon: <FaUsers /> },
    ],
  },
  {
    title: "THIẾT KẾ QUẢNG CÁO VỚI CANVA & AI",
    icon: <FaRobot className="banner__icon" />,
    items: [
      { text: "Canva + AI: Tạo layout, poster nhanh", icon: <FaMagic /> },
      { text: "Thiết kế banner, namecard, flyer", icon: <FaPaintBrush /> },
      { text: "Xây dựng bộ ấn phẩm marketing", icon: <FaPalette /> },
      { text: "Có sản phẩm thực hành riêng", icon: <FaUsers /> },
    ],
  },
  {
    title: "SẢN XUẤT VIDEO QUẢNG CÁO",
    icon: <FaFilm className="banner__icon" />,
    items: [
      { text: "Dựng phim với CapCut", icon: <FaFilm /> },
      { text: "Viết kịch bản quảng cáo", icon: <FaVideo /> },
      { text: "Quảng cáo 1–2 phút hoàn chỉnh", icon: <FaBullhorn /> },
      { text: "Ứng dụng ngay cho kinh doanh", icon: <FaUsers /> },
    ],
  },
];

const TrainingTourBanner = () => {
  return (
    <section className="banner">
      <div className="banner__overlay" />

      <div className="banner__content">
        <h1 className="banner__title">
          <FaGraduationCap className="banner__icon" /> CHƯƠNG TRÌNH ĐÀO TẠO
          “TRAINING TOUR”
        </h1>
        <p className="banner__subtitle">
          4 khóa/tháng – Thứ Bảy hàng tuần – Học phí chỉ{" "}
          <strong>299K/khóa</strong> - Cấp chứng nhận Design24 & Đơn vị liên kết
        </p>

        <div className="banner__cards">
          {trainingPrograms.map((program, idx) => (
            <div
              className="banner__card"
              key={idx}
            >
              <h2 className="banner__card-title">
                {program.icon} {program.title}
              </h2>
              <ul className="banner__card-list">
                {program.items.map((item, i) => (
                  <li key={i}>
                    {item.icon} {item.text}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrainingTourBanner;
